module.exports = __webpack_public_path__ + "img/alex_journey_grey.3a0ef108.svg";